import React from 'react'
import { Col, Row } from 'antd'
import loaderSVG from '../../assets/images/loader.svg'

function Render2Column(props){

    return(
        <Row className='custom-child' gutter={[16, 16]}>
            <Col md={12}>
                { props.col1 }
            </Col>
            <Col md={12}>
                { props.col2 }
            </Col>
        </Row>
    )

}

function Loader(){

    return (
        <div className="loader">
            <div className="loader_overlay"></div>	
            <img className="loader_img" src={loaderSVG} alt='loader'/>
        </div>
    )

}

function MiniLoader(){

    return (
        <div className="miniloader">
            <img className="loader_img" src={loaderSVG} alt='loader'/>
        </div>
    )

}

function downloadFile(ext="", basefile, filename="download.xls"){
    var mimeType = "";

    if(ext == ""){
        ext = filename.split('.').pop();
    }

    switch (ext) {
        case "xls":
        case "xlt":
        case "xla":
            mimeType = "application/vnd.ms-excel";
            break;

        case "xlsx":
            mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            break;

        case "xlsm":
            mimeType = "application/vnd.ms-excel.sheet.macroEnabled.12";
            break;

        case "xlam": 
            mimeType = "application/vnd.ms-excel.addin.macroEnabled.12";
            break;
        
        case "xlsb":
            mimeType = "application/vnd.ms-excel.sheet.binary.macroEnabled.12";
            break;
        
        case "xltm":
            mimeType = "application/vnd.ms-excel.template.macroEnabled.12";
            break;

        default:
            mimeType = "application/vnd.ms-excel";
            break;
    }

    //console.log(mimeType);
    //console.log(basefile);

    //basefile = encodeURIComponent(basefile);
    
    const linkSource = `data:${mimeType};base64,${basefile}`
    //const linkSource = `data:application/vnd.ms-excel;base64,${pdf}`
    //application/vnd.ms-excel
    const downloadLink = document.createElement("a")
    downloadLink.href = linkSource
    downloadLink.setAttribute('download', filename);
    downloadLink.target = "_blank"
    downloadLink.click()
}

export { Render2Column, Loader, MiniLoader, downloadFile }